import { Button, Modal, Box } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import LocalCarWashIcon from "@mui/icons-material/LocalCarWash";
import AddIcon from "@mui/icons-material/Add";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useTranslation } from "react-i18next";

const BasicModal = (props: {
  setVisibleModal: Dispatch<SetStateAction<string>>;
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleClickOption = (modalType: string) => {
    props.setVisibleModal(modalType);
    handleClose();
  };

  return (
    <Box>
      <Button variant="contained" onClick={handleOpen} startIcon={<AddIcon />}>
        {t("carWashes.addCarWash")}
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="flex justify-center items-center p-4"
      >
        <Box className="rounded-lg bg-white p-4 sm:p-5 w-full max-w-md sm:max-w-lg">
          <Box
            id="modal-modal-description"
            sx={{ mt: 2 }}
            className="flex flex-col sm:flex-row justify-center sm:justify-around gap-4"
          >
            <Button
              variant="contained"
              onClick={() => handleClickOption("owner")}
              className="flex flex-col w-full sm:w-64 h-48 sm:h-64"
            >
              <AccountCircleIcon
                sx={{
                  width: 64,
                  height: 64,
                  "@media (min-width: 640px)": { width: 128, height: 128 },
                }}
              />
              <Box className="mt-2 sm:mt-4 font-semibold text-center">
                {t("manageCarWashes.createOwner")}
              </Box>
            </Button>
            <Button
              variant="outlined"
              onClick={() => handleClickOption("carWash")}
              className="flex flex-col w-full sm:w-64 h-48 sm:h-64"
            >
              <LocalCarWashIcon
                sx={{
                  width: 64,
                  height: 64,
                  "@media (min-width: 640px)": { width: 128, height: 128 },
                }}
              />
              <Box className="mt-2 sm:mt-4 font-semibold text-center">
                {t("manageCarWashes.createCarWash")}
              </Box>
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default BasicModal;
